





















































































































































































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { Role } from '@/interfaces/Models';
import { LocaleMessage } from 'vue-i18n';
import { Action, Getter } from 'vuex-class';

@Component
export default class AccountWizard extends Vue {
  public roleId: number = 2;

  public address: any = {
    city_id: null,
    address: '',
    area_name: '',
  };
  public locale: string = 'en';

  public locales: any = [
    { value: 'English', id: 'en' },
    { value: 'Serbian', id: 'sr' },
  ];

  public roles: Role[] = [];
  public rolesLoading: boolean = true;

  public roleIcons: any = {
    'Super Admin': 'mdi-account-star',
    Admin: 'mdi-account',
    Parent: 'mdi-human-male-female',
    Babysitter: 'mdi-human-female-boy',
    'Potential Parent': 'mdi-human-male-female',
    'Potential Babysitter': 'mdi-human-female-boy',
  };

  public first: string = '';
  public firstRules: ((v: string) => void)[] = [
    (v: string) => !!v || 'First name is required',
  ];

  public last: string = '';
  public lastRules: ((v: string) => void)[] = [
    (v: string) => !!v || 'Last name is required',
  ];

  public email: string = '';
  public emailRules: ((v: string) => void)[] = [
    (v: string) => !!v || 'E-mail is required',
    (v: string) =>
      /^\w+([+\.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      'E-mail must be valid',
  ];

  public enablePassword: boolean = false;
  public password: string = '';
  public passwordRules: ((v: string) => void)[] = [
    (v: string) => !!v || 'Password is required',
    (v: string) => {
      if (v && v.length > 0 && v.length < 8) {
        return 'Password needs minimum of 8 characters.';
      }
      return true;
    },
  ];

  public confirmPassword: string = '';
  public confirmPasswordRules: ((v: string) => void)[] = [
    (v: string) => !!v || 'You have to confirm password',
    (v: string) => !(v !== this.getPassword()) || 'Passwords do not match',
  ];

  public cityRules: ((v: string) => void)[] = [
    (v: string) => !!v || 'City is required',
  ];

  public passwordHidden: boolean = true;

  public tab: number = 0;

  public get tabs() {
    const tabs = [
      this.$t('users.wizard.account'),
      this.$t('users.wizard.type'),
    ];

    if (
      (this.roleId && this.getSelectedRole()?.name == 'Babysitter') ||
      this.getSelectedRole()?.name == 'Parent' ||
      this.getSelectedRole()?.name == 'Potential Parent'
    ) {
      tabs.push(this.$t('users.wizard.additional-info'));
    }

    return tabs;
  }

  public valid: boolean = false;

  public $refs!: {
    form: HTMLFormElement; // fix for this.$refs.form.valdiate(); TS error
  };

  get getRoleId() {
    return this.roleId;
  }

  public getSelectedRole() {
    return this.roles.find((role) => role.id == this.roleId);
  }

  public getPassword(): string {
    return this.password;
  }

  get scope(): LocaleMessage {
    if (this.tab === 0) {
      return this.tabs[this.tab];
    } else if (this.tab === 2) {
      return this.tabs[this.tab];
    }

    return 'account';
  }

  get availableSteps() {
    const steps = [0];

    if (
      this.first &&
      this.last &&
      this.email &&
      (this.enablePassword ? this.password && this.$refs.form.validate() : true)
    )
      steps.push(1);

    if (this.getRoleId && steps.includes(1)) steps.push(2);

    if (this.address.city_id && steps.includes(2)) steps.push(3);

    return steps;
  }

  public next(valid: boolean): void {
    if (!valid) return;

    if (this.tab === this.tabs.length - 1) {
      this.submit();
    } else {
      this.tab++;
    }
  }

  public resetForm() {
    this.tab = 0;
    this.$refs.form.reset();
  }

  public async submit(): Promise<void> {
    const PART_TIME_INQUIRY_TEMPLATE = 'pt_inquiry_parents';
    let params: any = {
      first_name: this.first,
      last_name: this.last,
      email: this.email,
      password: this.enablePassword
        ? this.password
        : this.generateRandomPassword(),
      role: this.roleId,
      address: this.address,
      password_setup: !this.enablePassword,
      locale: this.locale,
    };
    const selectedRole = this.getSelectedRole()
      ? this.getSelectedRole()!.name
      : '';
    const potentialRole = this.isPotentialRole(selectedRole || 'None');

    if (potentialRole) {
      params['address'] = {
        city_id: this.address.city_id,
      };
    }

    const url = potentialRole
      ? api.path('v1.admin.users.potential')
      : api.path('v1.admin.users');

    const createUserResponse = await axios.post(url, params);
    if (potentialRole) {
      const urlParams = new URLSearchParams({
        parentIdentifier: createUserResponse.data.email_identifier,
        email: this.email,
        firstName: this.first,
        lastName: this.last,
        locale: this.locale,
        cityId: this.address.city_id,
      });

      const familyQuestionnaireUrl = `${process.env.VUE_APP_WEBSITE}/${
        this.locale
      }/questionnaire-parent/?${urlParams.toString()}`;

      type Locale = 'en' | 'sr';
      const subjectTranslations: { [key in Locale]: string } = {
        en: "Babysitters' Club - Part time babysitting service",
        sr: "Babysitters' Club - Ponuda za povremeno čuvanje dece",
      };
      const locale: Locale = this.locale as Locale;
      const emailParams = {
        to: this.email,
        template: `${PART_TIME_INQUIRY_TEMPLATE}_${this.locale}`,
        subject: subjectTranslations[locale],
        variables: {
          firstName: this.first,
          url: familyQuestionnaireUrl,
        },
        user_id: createUserResponse.data.user_id,
        type: 'pt_offer',
      };

      const emailResponse = await axios.post(
        api.path('v1.admin.emails'),
        emailParams
      );

      return this.$toast.success(emailResponse!.data!.message); //
    }
    this.$toast.success(createUserResponse.data.message); // Assuming the message is in response.data.message
    this.resetForm();
  }

  public getRoles() {
    let params = {
      paginate: 'no',
    };

    axios
      .get(api.path('v1.admin.roles'), { params: params })
      .then((res) => {
        // Remove Potential Babysitter role because it will never be needed
        // to add manually
        const roles = res.data.data.filter((role: Role) => {
          return role.name !== 'Potential Babysitter';
        });
        this.setRoles(roles);
      })
      .finally(() => (this.rolesLoading = false));
  }

  public setRoles(roles: Role[]): void {
    this.roles = roles;
  }

  @Action('cities/fetchCities') fetchCities: any;
  @Getter('cities/cities') cities: any;

  public mounted() {
    this.getRoles();
    this.fetchCities();
  }

  public isPotentialRole(roleName: string): boolean {
    return (
      roleName === 'Potential Parent' || roleName === 'Potential Babysitter'
    );
  }
  public generateRandomPassword(): string {
    return Math.random()
      .toString(36)
      .slice(-9);
  }
}
